const paymentStatus = {
  downloadImageTooltip: "View/Download Cheque Image",
  moreOptionsLables: {
    uploadCheck: "Import Cheque Images",
    uploadBankActivities: "Upload Bank Activities",
  },
  paymentStatusTab: {
    payments: "Payments",
    bankTransactions: "Bank Transactions",
  },
  breadCrums: {
    createPayment: "New Manual Payment",
  },
  bankTransactions: {
    tableTitle: "Pending Bank Transactions",
    tableDescription:
      "This table shows the banking activity that is NOT consistent with information already existing for this case. Examples include: Payments that have previously been cashed, payments where the cheque number or amount are different that the expected amount, payments that have been voided, stopped, or never issued.",
    markAsResolved: "Mark as Resolved",
    columnDetails: {
      groupNumber: "Group Number",
      subGroupNumber: "Sub Group Number",
      currency: "Currency",
      debtorCreditorIndicator: "Debtor/Creditor Indicator",
      transactionCode: "Transaction Code",
      description1: "Description 1",
      description2: "Description 2",
      serialNumber: "Serial Number",
      institutionNumber: "Institution Number",
      transitNumber: "Transit Number",
      accountNumber: "Account Number",
      effectiveDate: "Effective Date",
      postingDate: "Posting Date",
      amount: "Amount",
      immediateAvailability: "Immediate Availability",
      oneDayAvailability: "One Day Availability",
      twoPlusAvailability: "Two Plus Availability",
      updatedOn: "Updated On",
      yes: "Yes",
      no: "No",
    },
    transactionResolvedMessage:
      "Are you sure you would like to resolve the selected bank transactions",
  },
  columnDetails: {
    column1: "Payment Reference",

    column2: "Payee Name",

    column3: "Account Name",

    column4: "Amount",

    column5: "Payment Status",

    column6: "Prefix",

    column7: "Replacement ID",

    column8: "Issue Date",

    column9: "Posted Date",

    column10: "Status Update Date",
    column11: "Attachment",
    column12: "Distribution Name",
    column13: "Updated By",
    column14: "Sub Account",
    column15: "Voided Date",
    column16: "Settlement Date",
  },
  paymentStatusUpdate: "Payment status updated successfully.",
  addStatusInfoMessage:
    "Please reach out to a Case Manager or System Admin to make this update.",
  importSummaryLabel: "View Import Summary",
  statusGridTitle: "Payment Status",
  newPaymentButton: "New Manual Payment",
  statusGridDescription:
    "This table shows that status of all payments in this Case. Payments must be Voided to be replaced. The status of Draft payments should be set to 'Issued' when the payments are released. Payments are are either not released, or returned to us should be set to 'Undelivered'.",
  noRecord: "No record found.",
  updateStatusButton: "Update payment status",
  updateStatusLabel: "Payment Status Update",
  updateStatusLabelWithStatus:
    "Payment Status Update - Current Status: {{currentStatus}}",
  sameStatusValidationMessage:
    "Selected payments must have the same Payment Status.",
  updateStatusToLabel: "Update status to:",
  postedDateRequired: "Posted Date is required.",
  emptyStatusValidationMessage:
    "No payment status available if status is {{paymentStatus}}",
  clearFilter: "Clear Filter",
  postedDate: "Posted / Replaced Date",
  somethingWentWrong: "Something went wrong.",
  deletePayment: "Delete Payment",
  deletePaymentMessage:
    "Are you sure you want to delete this payment <strong>{{paymentReference}}</strong>?",
  confirm: "Confirm",
  filterForm: {
    title: "Payment Filters",
    description:
      "Open the filtering panel by clicking on the down arrow on 'Filters' button",
    filterButton: "Filters",
    payeeName: "Payee Name",
    accountName: "Account Name",
    prefix: "Prefix",
    paymentReferenceStart: "Payment Reference (Begins With)",
    paymentReferenceEnd: "Payment Reference (Ends With)",
    issueDate: "Issue Date",
    amountInLowerBound: "Amount (Lower Bound)",
    amountInUpperBound: "Amount (Upper Bound)",
    postedDate: "Posted / Replaced Date",
    addressUpdateDate: "Address Update Date",
    status: "Status",
    cancel: "Cancel",
    apply: "Apply",
    save: "Save",
  },
  paymentSummary: {
    summaryTitle: "Payment Summary",
    summaryDescription: "Descriptive text that describes your page or content.",
    tableTitle: "Settlements",
    tableDescription:
      "This table provides a breakdown of the payment by Claim Element, including the Entitlement and Previous Settlements at the time the payment was first settled.",
    paymentReference: "Payment Reference",
    account: "Account",
    subAccount: "Sub Account",
    payeeName: "Payee Name",
    amount: "Amount",
    prefix: "Prefix",
    issueDate: "Issue Date",
    status: "Status",
    attachment: "Attachment",
    tableColumnHeader: {
      claimItemId: "Claim Element ID",
      category: "Category",
      resolvedAmount: "Resolved Amount ({{unitName}})",
      class: "Class",
      entitlementAmount: "Entitlement Amount",
      priorSettledAmount: "Prior Settled Amount",
      settlementAmount: "Settlement Amount",
    },
  },
  bulkChequeImport: {
    title: "Import Cheque Images",
    uploadDescription:
      "The accepted archive format is ZIP only. The maximum size per file is 500 MB.",
    accept: ".zip",
    beforeUploading: "Before uploading:",
    instruction1: "Ensure all cheque files are in an accepted format:",
    instruction1Sub:
      "PDF (.pdf), Images (.jpg, .jpeg, .png, .gif, .tiff), Word (.doc, .docx), Excel (.xls, .xlsx), Outlook (.msg)",
    instruction2: "All files follow this naming format:",
    instruction2Example:
      "e.g. CAD_0001_CreditorName.pdf, CAD_0001_CreditorName.jpg, CAD_0001.msg",
    instruction3: "Place all files into a single ZIP file",
    instruction3Sub: "Files may be organized in folders if needed",
    instruction4: "Open the ZIP file and confirm all accepted files are included (inside folders or at the top level)",
  },
  bankActivitiesImport: {
    title: "Upload Bank Activities",
    uploadDescription:
      "The accepted document format is csv & txt only. The maximum file size is 250 MB.",
    accept: ".csv, .txt",
  },
  paymentSetup: {
    title: "Manual Payment",
    description:
      "Manual Payments can be used to issue individual payments, including wires and cross currency payments on an exception basis. In the event of a return of funds, the Manual Payments can also be used to reverse or partially reverse an overpayment. Manual Payments will generate payment reference using the next available payment reference as defined by the Account from which the payment is being made. The Manual payment date will be the current distribution date as defined for the current distribution.",
    sideTabPanelDetails: {
      details: "Payment Details",
      claims: "Select a Claim",
      claimItems: "Select Claim Elements",
    },
    details: {
      distribution: "Distribution",
      subAccount: "Sub Account",
      prefix: "Prefix",
      generatePaymentBy: "Generate Payment By",
      netPayment: "Net Payment",
      upadateIndividualClaimItem: "Update individual Claim Element",
      paymentAmount: "Payment Amount",
      unit: "Payment Unit",
      exchangeRate: "Exchange Rate ({{selectedUnit}} to {{accountUnit}})",
      selectCreditor: "Select a Creditor",
      generatePayment: "Generate Payment",
      distributionRequired: "Distribution is required.",
      subAccountRequired: "Sub Account is required.",
      generatePaymentRequired: "Generate Payment By is required.",
      paymentAmountRequired: "Payment Amount is required.",
      unitRequired: "Unit is required.",
      exchangRateRequired: "Exchange Rate is required.",
      creditorRequired: "Creditor selection required.",
      invalidNonZeroNumber: "Enter a valid non - zero number.",
      invalidNumber: "Required positive number or decimal number.",
      prefixReq: "Prefix is required.",
      cheque: "Cheque",
      statement: "Statement",
      wire: "Wire",
      other: "Other",
      subAccountListError:
        "Please create a sub-account and associate it with a payable step to be able to a generate a manual payment.",
      creditorNotExist: "Creditor does not exist",
      creditorSummaryInfo: {
        additionalPayeeType: "Additional Payee Type",
        prefix: "Prefix",
        primary: "Primary",
        payeeName: "Payee Name: {{payeeName}}",
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        phoneNumber: "Phone Number",
        fax: "Fax",
        relationshipToCreditor: "Relationship to Creditor",
        country: "Country",
        city: "City",
        address1: "Address 1",
        address2: "Address 2",
        address: "Address",
        postalCode: "Postal Code",
        provinceState: "Province State",
        paymentDetails: "Payment Details",
        institutionNumber: "Institution Number",
        transitNumber: "Transit Number",
        accountNumber: "Account Number",
        IBANNumber: "IBAN Number",
        SWIFTCode: "SWIFT Code",
        routingCode: "Routing Code",
        ACHCode: "ACH Code",
      },
    },
    claim: {
      title: "Select a Claim under Creditor: {{creditorName}}",
      description: "Select the Claim to be associated with this Manual Payment",
      claimRequired: "Please select a claim.",
      tableColumnsDetails: {
        claimId: "Claim ID",
        assignee: "Assignee",
        originalAmount: `Original Amount {{unitName}}`,
        resolvedAmount: `Resolved Amount {{unitName}}`,
        Stage: "Stage",
        status: "Status",
      },
    },
    claimItems: {
      title: "Claim Elements (Claim ID: {{claimReferenceId}})",
      description:
        "Select all Claim Elements that are to be associated with the Manual Payment (usually all). Once selected, press the 'Add to Payment' button.",
      addToPayment: "Add to Payment",
      tableColumnsDetails: {
        claimItemId: "Claim Element ID",
        category: "Category",
        currentAmount: `Current {{unitName}}`,
        resolvedAmount: `Resolved {{unitName}}`,
        entitlement: "Entitlement",
        priorSettled: "Prior Settled",
        settlement: "Settlement",
      },
    },
    manualPayment: {
      title: "Generate Manual Payment",
      description:
        "This table summarizes by Claim Element the current Entitlement and previous amounts settlement for those Claim Elements. The Settlement column shows how the current payment is being allocated to the Claim Elements.",
      total: "Total",
    },
  },
};
export default paymentStatus;
